import React, { useState, forwardRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const SignUp = forwardRef(({ onSuccess }, ref) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { signUp } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      setLoading(false);
      return;
    }

    try {
      // Use Firebase authentication
      await signUp(formData.email, formData.password, formData.name);
      
      // The AppContent component will handle routing to onboarding
      onSuccess();
      
    } catch (error) {
      setError(error.message || 'An unexpected error occurred');
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card" ref={ref}>
        <div className="auth-header">
          <h2>Unlock Crypto Analysis</h2>
          <p>Sign up to access real-time cryptocurrency data and AI-powered technical analysis</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Create a password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Confirm your password"
            />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Creating Account...' : 'Start 7-Step Onboarding'}
          </button>
        </form>

        <div className="auth-features">
          <h3>What you'll get:</h3>
          <ul>
            <li>✅ 7-step personalized onboarding</li>
            <li>✅ Real-time cryptocurrency prices</li>
            <li>✅ AI-powered technical analysis</li>
            <li>✅ Advanced trading indicators</li>
            <li>✅ Market insights and trends</li>
            <li>✅ Portfolio tracking tools</li>
          </ul>
        </div>
      </div>
    </div>
  );
});

export default SignUp; 